import { render } from "./Hotspot12.vue?vue&type=template&id=e7168bd2&scoped=true&ts=true"
import script from "./Hotspot12.vue?vue&type=script&lang=ts"
export * from "./Hotspot12.vue?vue&type=script&lang=ts"

import "./Hotspot12.vue?vue&type=style&index=0&id=e7168bd2&scoped=true&lang=scss"

import exportComponent from "/data/.jenkins/workspace/k8s-shouba-exhibitionhall-h5-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e7168bd2"]])

export default __exports__